export interface ApiTransferQueryRequest {
    query: string;
    search_from: string;
}

export interface ApiTransferQueryResponse  {
    q: string;
    type: string;
}

export const TransferQuery = Symbol('TransferQuery');

export interface TransferQuery {
    transferQuery(data: ApiTransferQueryRequest): Promise<ApiTransferQueryResponse>;
}